import {Injectable} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {ModifyAddressDialogComponent, ModifyAddressDialogResultInterface} from "./modify-address-dialog.component";
import {AddressModel, addressModelFactory} from "./address.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class AddressService {
  modifyAddress(targetType: string, targetId: string): Promise<ModifyAddressDialogResultInterface> {
    return ModifyAddressDialogComponent.showAddressModal(
      this.dialogService,
      targetType,
      targetId,
    );
  }

  getAddress(params: {[key: string]: string}): Promise<AddressModel> {
    return this.http.get<AddressModel>(`/api/address`, {params})
      .pipe(map(json => addressModelFactory(json)))
      .toPromise();
  }

  updateAddress(params: {[key: string]: string}, address: AddressModel): Promise<AddressModel> {
    return this.http.post<AddressModel>(`/api/address`, {address}, {params})
      .pipe(map(json => addressModelFactory(json)))
      .toPromise();
  }

  constructor(
    private dialogService: DialogService,
    private http: HttpClient,
  ) {}
}
